import socketIo, { Socket } from 'socket.io-client';
import { SOCKET_HOST } from 'src/config-global.js';

export type EventFnReturn = (io: Socket) => () => void;
export type EventFn<P> = (listaner: (p: P) => void) => EventFnReturn;

export const ioFactory = ({
  authorization,
  deviceId,
  namespace,
}: {
  authorization: string;
  deviceId?: string;
  namespace?: string;
}) => {
  let query = authorization || deviceId ? {} : undefined;
  if (authorization) {
    query = { ...query, authorization };
  }
  if (deviceId) {
    query = { ...query, deviceId };
  }
  const io = socketIo(`${SOCKET_HOST}/${namespace || 'private'}`, {
    transports: ['websocket'],
    query,
    forceNew: true,
  });

  io.on('disconnect', (reason) => {
    //? socket.io attempts to reconnect, do nothing
    if (io.active) return;

    // we don't care about other reasons, because we never call disconnect on the client
    // @see https://socket.io/docs/v4/client-socket-instance/#disconnect
    if (reason !== 'io server disconnect') return;

    console.info('socket disconnected by server, attempting to reconnect...');

    let delay = 1000;
    let timeout: NodeJS.Timeout | null = null;

    const handleTryReconnect = () => {
      if (io.connected) {
        console.info('socket reconnected, stopping reconnect attempts...');
        clearTimeout(timeout!);
        return;
      }

      console.info('attempting to reconnect...');

      io.connect();

      delay = Math.min(delay * 2, 10_000);
      timeout = setTimeout(handleTryReconnect, delay);
    };

    timeout = setTimeout(handleTryReconnect, delay);

    io.io.on('reconnect', handleTryReconnect);
  });

  return io;
};

// socketIo(SOCKET_HOST, {
//   path: namespace ? `/socket.io/${namespace}` : '/socket.io',
//   transports: ['websocket'],
//   query: {
//     authorization,
//   },
//   forceNew: true,
// });

export const addListener =
  <P>(event: string): EventFn<P> =>
  (cb) =>
  (io) => {
    io.on(event, cb);
    return () => io.off(event, cb);
  };

export const addIOListener =
  <P>(event: string): EventFn<P> =>
  (cb) =>
  (io) => {
    io.io.on(event as any, cb);
    return () => io.io.off(event as any, cb);
  };
